import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/Dash.css";
import axios from 'axios';
import { GridLoader } from 'react-spinners';
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { subscribe } from "./eventBus";

function Dash() {

  const navigate = useNavigate();
  const [filter, setFilter] = useState('');
  const [isAdmin, setisAdmin] = useState(false);

  const [notifications, setNotifications] = useState([]);

  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const [rowsPerPage, setRowsPerPage] = useState(9); // Update rows per page to 10

  const [showNotificationModal, setShowNotificationModal] = useState(false);

  const [message, setMessage] = useState('');
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([])
  const [showverifyModal, setShowVerifyModal] = useState(false);
  const [licenses, setLicenses] = useState({})

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedSKU, setSelectedSKU] = useState("");

  const [showLicenseModal, setShowLicenseModal] = useState(false);
  const [licenseKey, setLicenseKey] = useState("");
  const [licenseError, setLicenseError] = useState("");


  const baseURL = sessionStorage.getItem('baseURL')
  useEffect(() => {
    const calculateRows = () => {
      const viewportHeight = window.innerHeight;

      const header = 280;
      const search = 60;
      const tableHead = 50;
      const footer = 80;

      const usableHeight =
        viewportHeight - header - search - tableHead - footer;

      const rowHeight = 63;
      const rows = Math.floor(usableHeight / rowHeight);
      setRowsPerPage(rows >= 2 ? rows : 2);
    };

    calculateRows();
    window.addEventListener("resize", calculateRows);
    return () => window.removeEventListener("resize", calculateRows);
  }, []);

  const fetchImageAsDataURL = async (imageUrl) => {
    try {
      const response = await axios.get(imageUrl, { responseType: "arraybuffer" });
      const blob = new Blob([response.data], { type: response.headers["content-type"] });

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching and converting image:", error);
      throw error;
    }
  }

  const fetchImage = (row) => {
    fetchImageAsDataURL(baseURL + "sku/SKUImage/" + row.product_image.replaceAll("/", "-"))
      .then((dataURL) => {
        setSelectedSKU(prevState => ({ ...prevState, image: dataURL }));
      })
  }

  function showToast(message, type = "success") {
    const toast = document.createElement("div");
    toast.innerText = message;

    Object.assign(toast.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      background: type === "error" ? "#d32f2f" : type === "success" ? "#2e7d32" : "#ffa000",
      color: "#fff",
      padding: "12px 18px",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      zIndex: 9999,
      opacity: "0",
      transition: "opacity 0.3s ease"
    });

    document.body.appendChild(toast);

    requestAnimationFrame(() => (toast.style.opacity = "1"));

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }
  const handleLicenseSubmit = (e) => {
    e.preventDefault();

    if (checkLicense()) {
      axios.get(baseURL + 'sku/submitLicense/' + licenseKey + "/" + selectedSKU.sku_id + "/" + selectedSKU.brand_name, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
        })
        .then(response => {
          // showToast("License submitted successfully");
          // Close the modal after submission
          setShowLicenseModal(false);
          setLicenseKey("");
          setLicenseError("");
          fetchDetails();
        })
        .catch(error => {
          console.error("Error submitting license:", error);
        });
    }
  };

  const processSkuData = (skuRows, licensesObj) => {

    if (!Array.isArray(skuRows)) {
      console.error("Invalid skuRows:", skuRows);
      return;
    }

    const validLicenses = licensesObj?.valid || [];
    const expiredLicenses = licensesObj?.expired || [];

    /* -------- FAST LOOKUPS -------- */
    // const existingSkuSet = new Set(
    //   skuRows.map(row => { return row.sku_id; })
    // );

    const licenseValidSet = new Set(
      validLicenses.map(item => item.lic_no)
    );

    const expiredValidSet = new Set(
      expiredLicenses.map(item => item.lic_no)
    );

    /* -------- TABLE DATA -------- */
    const updatedTableData = skuRows.map(row => {
      const lic = row.license_group;
      const validity = licenseValidSet.has(lic) ? 'active' : expiredValidSet.has(lic) ? 'expired' : 'not-verified'
      return {
        ...row,
        license_valid: validity
      };
    });

    /* -------- SET STATE -------- */
    setTableData(updatedTableData);

    let fD = Object.values(updatedTableData).filter(item =>
      Object.values(item).some(value =>
        value != null &&
        String(value).toLowerCase().includes(filter.toLowerCase())
      )
    );
    setFilteredData(fD);
    setLicenses(validLicenses);//updatedLicenses);
  };

  useEffect(() => {
    // create a loop which runs for every second
    const interval = setInterval(() => {
      for (let i = 0; i < filteredData.length; i++) {
        const currentTime = new Date();
        let rowTime = new Date(filteredData[i].timestamp);
        rowTime.setHours(rowTime.getHours() + 24);
        const timeDiff = currentTime - rowTime;
        setFilteredData(prevData => {
          const updatedData = [...prevData];
          updatedData[i] = { ...updatedData[i], 'timeLeft': timeDiff };
          return updatedData;
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [tableData]);


  const handleError = (error) => {
    console.error("Error fetching SKU:", error);
  };

  const fetchDetails = async () => {
    sessionStorage.setItem('skuId', '');
    var url = baseURL + "license/alllicense";
    axios.get(url).then((response) => {

      /* ---------------- BUILD LICENSE OBJECT ---------------- */

      const licenses = {
        valid: [],
        expired: []
      };

      for (let i = 0; i < response.data.length; i++) {
        const data = response.data[i];

        const names = data.sku_name;
        const skus = data.sku_id

        if (data.status)
          // ✅ VALID LICENSE
          licenses.valid.push({
            name: names,
            sku_id: skus,
            lic_no: data.lic_no,
            group_name: data.groups,
            startDate: data.start_date,
            created: false
          });
        else
          // ✅ EXPIRED LICENSE
          licenses.expired.push({
            name: names,
            sku_id: skus,
            lic_no: data.lic_no,
            group_name: data.groups,
            startDate: data.start_date,
            created: false
          });

      }


      /* ---------------- FETCH EXISTING SKUs ---------------- */
      let groupid = ""
      if (sessionStorage.getItem('isAdmin') === "true") {
        groupid = "all"
      }
      else {
        groupid = sessionStorage.getItem('group_id')
      }
      /* ---------------- FETCH SKU ---------------- */

      if (groupid === "all") {

        /* 🔹 CASE: ALL PRODUCTION UNITS */
        axios.get(baseURL + "sku/fetchSku/all")
          .then((skuResponse) => {
            processSkuData(skuResponse.data, licenses)
          })
          .catch(handleError);

      } else {

        axios.get(baseURL + `sku/fetchSku/${groupid}`)
          .then(responses => {
            const mergedRows = responses.data
            processSkuData(mergedRows, licenses);
          })
          .catch(handleError);
      }


    }).catch((error) => {
      console.error("Error fetching licenses:", error);
    });

  }

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') !== "true") {
      navigate('/', { replace: true });
    }
    else if (sessionStorage.getItem('password_changed') !== "true") {
      navigate('/change-password');
    }
    else if (sessionStorage.getItem('isAdmin') === "true") {
      setisAdmin(true);
    }
    document.getElementById('loading').hidden = true
    fetchDetails();

    if (sessionStorage.getItem('isAdmin') !== "true") {
      fetchNotification();

      const unsubscribe = subscribe((event) => {
        if (event.type !== "NOTIFICATION") return;
        // ✅ Refresh only batch data
        fetchNotification();
      });

      return unsubscribe;
    }
  }, [navigate]);

  const formatTime = (cdT) => {
    let countdownTime = Math.abs(cdT) / 1000; // milliseconds → seconds

    const hours = Math.floor(countdownTime / 3600);
    const minutes = Math.floor((countdownTime % 3600) / 60);
    const seconds = Math.floor(countdownTime % 60);
    if(hours > 0){
      if(minutes > 0){
        return `${hours}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
      }
      return `${hours}h ${seconds.toString().padStart(2, '0')}s`;
    }
    else{
      if(minutes > 0){
        return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
      }
      return `${seconds.toString().padStart(2, '0')}s`;
    }
};

  const fetchNotification = () => {
    axios.get(baseURL + "notifications/unread", {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    })
      .then(res => res.data)
      .then(setNotifications);
  };

  useEffect(() => {
    if (notifications.length === 0) {
      setShowNotificationModal(false);
    }
  }, [notifications]);

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const ViewDetails = (row) => {
    sessionStorage.setItem('skuId', JSON.stringify(row));
    navigate('/sku-dashboard');
  }
  const Validate = (row) => {
    document.getElementById('loading').hidden = false
    axios.get(baseURL + `sku/validateSKU/${row.sku_id}/${row.license_group}`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
    })
      .then((response) => {
        document.getElementById('loading').hidden = true
        if (response.data.message) {
          setShowViewModal(false);
          fetchDetails();
          showToast("Product Added Successfully");
          return;
        }
      })
      .catch((error) => {
        console.error("Error validating SKU:", error);
      });
  };

  const updateSKUDetails = (row) => {

    sessionStorage.setItem('skuData', JSON.stringify(row))
    navigate('/update-sku')
  }
  const verifyBrowser = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      setMessage("You are using Android Web. Please use Desktop Browser.");
      setShowVerifyModal(true)
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      setMessage("You are using iOS Web. Please use Desktop Browser.");
      setShowVerifyModal(true)
    } else {
      sessionStorage.setItem('set', 'false'); navigate('/analytics')
    }
  }

  const checkLicense = () => {
    const lic = licenseKey.trim();

    const isValid = licenses.valid.some(
      item => item.lic_no === lic
    );

    const isBelongsTo = licenses.valid.some(
      item => item.sku_id === selectedSKU.sku_id
    );

    //check start date if today or earlier 
    const isActive = licenses.valid.some(
      item => new Date(item.startDate) <= new Date()
    );



    if (isValid && isBelongsTo && isActive) {
      return true
    }
    else if (!isBelongsTo) {
      setLicenseError("License does not belong to the selected SKU")
    }
    else if (!isValid) {
      setLicenseError("Invalid SKU")
    }
    else if (!isActive) {
      setLicenseError("License is not yet active")
    }
    return false
  };

  // Get the current slice of table data for the current page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  // Handle next page
  const nextPage = () => {
    if (currentPage < Math.ceil(filteredData.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handle previous page
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNotificationClick = (notification) => {
    const filtered_sku = tableData.filter(item => item.sku_id === notification.payload.sku_id)[0];
    if (!filtered_sku.disabled) {
      sessionStorage.setItem('skuId', JSON.stringify(filtered_sku));
      axios.get(baseURL + "qr/fetchSingleQR/" + filtered_sku.sku_id + "/" + notification.payload.qr_id).then((response) => {
        response.data = response.data[0]
        sessionStorage.setItem('qrId', response.data.qr_id);
        sessionStorage.setItem('qrUid', response.data.uid);
        sessionStorage.setItem('qrCreatedAt', response.data.timestamp);
        navigate('/batch-management');
      });
    }
  };

  const changeNotificationStatus = (notification) => {
    // Logic to change the notification status
    axios.get(baseURL + 'notifications/changeNotificationStatus/' + notification.id)
      .then((response) => {
        fetchNotification();
      })
      .catch((error) => {
        console.error("Error changing notification status:", error);
      });
  };

  return (
    <div className="dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="dashboard-actions">
          {/* Analytics button */}
          {/* Show Admins button only if isSuperAdmin is true */}
          {isAdmin && (
            <>
              <button
                className={`action-button`}
                onClick={() => navigate('/users')}
              >
                Production Unit Management
              </button>
              <button
                className={`action-button`}
                onClick={() => { sessionStorage.setItem('licenses', JSON.stringify(licenses)); navigate('/details-sku') }}
              >
                Add Product Details
              </button>
              <button
                className={`action-button`}
                onClick={() => navigate('/license')}
              >
                QRmor Licenses
              </button>
              <button
                className={`action-button`}
                onClick={verifyBrowser}
              >
                QRmor Analytics
              </button>
            </>
          )}
        </div>
        {!isAdmin && (
          <div className="notification-icon">
            {notifications.length > 0 ? (
              <button className='action-button' onClick={() => setShowNotificationModal(true)} >
                {/* icon with number indication how many present */}
                {/* on click of this element, should display a popup modal below the icon with notification details */}
                <label style={{ marginRight: '5px', cursor: 'pointer' }}>Notifications</label>
                <FontAwesomeIcon icon={faBell} />
                <span className="notification-count">{notifications.length}</span>
              </button>
            ) : (
              <button className='action-button' >
                {/* icon with number indication how many present */}
                {/* on click of this element, should display a popup modal below the icon with notification details */}
                <label style={{ marginRight: '5px', cursor: 'not-allowed' }}>Notifications</label>
                <FontAwesomeIcon icon={faBell} style={{ cursor: 'not-allowed' }} />
              </button>
            )}
          </div>)}
      </div>

      {/* Notification Modal */}
      {showNotificationModal && (
        <div className="notification-modal">
          <div className="notification-content">
            <h3>Notifications</h3>
            <table>
              {notifications.map((notification, index) => (
                <tr key={index} className="notification-item">
                  {/* <p>{JSON.stringify(notification)}</p> */}
                  <td>{notification.type} - {notification.payload.batch_no} for {notification.payload.uid} of {notification.payload.sku_name}</td>
                  <td>{notification.type === "Batch Added" || notification.type === "Batch Requested for Update" || notification.type === "Batch Updated" ? <button onClick={() => handleNotificationClick(notification)}>View</button> : <button onClick={() => changeNotificationStatus(notification)}>OK</button>}</td>
                </tr>
              ))}
            </table>

          </div>
          <button className="notification-button" onClick={() => setShowNotificationModal(false)}>Close</button>
        </div>
      )}

      {/* Filter and Generate QR Button Side by Side */}
      <div className="dashboard-filter-container">
        <div className="dashboard-filter">
          <div className="input-wrapper">
            <input
              type="text"
              id="filter-input"
              placeholder=" "
              value={filter}
              onChange={handleFilterChange}
            />
            <label htmlFor="filter-input">Filter table...</label>
          </div>
        </div>
      </div>

      {/* Table with scrolling */}
      <div className="dashboard-table">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>GTIN</th>
                <th>Generic Name</th>
                <th>Manufacturing Lic. No.</th>
                {isAdmin && <th>Production Unit</th>}
                <th>License Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((row) => (
                <tr key={row.sku_id}>
                  <td>{row.brand_name}</td>
                  <td>{row.gtin}</td>
                  <td>{row.generic_name}</td>
                  <td>{row.manufacturing_license}</td>
                  {isAdmin && <td>{row.prod_unit}</td>}
                  <td>{row.license_valid == 'active' ? <p style={{ cursor: 'pointer', fontSize: '.85rem', margin: '5px', color: 'green' }}>Active</p> : row.license_valid == 'expired' ? <p title="Renew and Enter License No. to View Details" style={{ cursor: 'pointer', fontSize: '.85rem', margin: '5px', color: 'red' }}>Expired</p> : <p style={{ cursor: 'pointer', fontSize: '.85rem', margin: '5px', color: 'orange' }}>{/* Add tooltip */}Not - Verified</p>}</td>
                  <td>
                    {isAdmin && row.timeLeft < 0 && (
                      <>
                        <div>Edit Window Expires in: {formatTime(row.timeLeft)}</div>
                        <button style={{ cursor: 'pointer', margin: '5px' }} onClick={() => { setSelectedSKU(row); fetchImage(row); setShowViewModal(true); }} >View & Edit Details</button>
                      </>
                    )}
                    {row.license_valid !== 'expired' ? <>
                      <button style={{ cursor: 'pointer', margin: '5px' }} onClick={() => ViewDetails(row)} >{isAdmin ? "Generate QR and View Details" : "Add and Validate Batch Details"}</button>
                    </> : <>{isAdmin && <button style={{ cursor: 'pointer', margin: '5px' }} onClick={() => { setShowLicenseModal(true); setSelectedSKU(row); }} >Enter License No.</button>}</>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button onClick={prevPage} disabled={currentPage === 1}>
          Previous
        </button>
        <span>
          Page {currentPage} of {Math.ceil(filteredData.length / rowsPerPage)}
        </span>
        <button onClick={nextPage} disabled={currentPage === Math.ceil(filteredData.length / rowsPerPage)}>
          Next
        </button>
      </div>

      <div className="loading" id='loading'>
        <GridLoader color="#4a5160" loading={true} size={20} />
      </div>

      {showViewModal && (
        <div className="sku_validate modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2 className="modal-title">
                <b>{selectedSKU.brand_name}</b> Details
              </h2>

              </div>
            <table>
              <tbody>
                <tr>
                  <th colSpan={2}>Product Details</th>
                </tr>
                <tr>
                  <td>License Key:</td>
                  <td>{selectedSKU.license_group}</td>
                </tr>
                <tr>
                  <td>Product Name:</td>
                  <td>{selectedSKU.brand_name}</td>
                </tr>
                <tr>
                  <td>GTIN:</td>
                  <td>{selectedSKU.gtin}</td>
                </tr>
                <tr>
                  <td>Generic Name:</td>
                  <td>{selectedSKU.generic_name}</td>
                </tr>
                <tr>
                  <td>Manufacturing Lic. No.:</td>
                  <td>{selectedSKU.manufacturing_license}</td>
                </tr>
                <tr>
                  <td>Production Unit:</td>
                  <td>{selectedSKU.prod_unit}</td>
                </tr>
                <tr>
                  <td>List of Excipients:</td>
                  <td>{selectedSKU.excipients}</td>
                </tr>
                <tr>
                  <td>Visit Us URL:</td>
                  <td><a style={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} onClick={() => window.open(selectedSKU.visiturl.includes("http") ? selectedSKU.visiturl : "http://" + selectedSKU.visiturl, "_blank")}>{selectedSKU.visiturl}</a></td>
                </tr>
                <tr>
                  <td colSpan={2}><img src={selectedSKU.image} alt="SKU" height="auto" width="100%" /></td>
                </tr>
              </tbody>
            </table>
            <div className="modal-buttons" style={{ marginTop: '5px' }}>
              <button onClick={() => setShowViewModal(false)}>Cancel</button>
              <button onClick={() => sessionStorage.setItem('licenses', JSON.stringify(licenses)) & updateSKUDetails(selectedSKU) & setShowViewModal(false)}>Edit</button>
            </div>
          </div>
        </div>
      )}

      {showverifyModal && (
        <div className="verify-modal">
          <div className="verify-content">
            <h2>Alert</h2>
            <p>{message}</p>
            <button onClick={() => setShowVerifyModal(false)} className="verify-button" >Close</button>
          </div>
        </div>
      )}

      {/* //Enter license modal */}
      {showLicenseModal && (
        <div className="license modal-overlay">
          <div className="modal-content">
            <h2>Enter License Details</h2>
            <form onSubmit={handleLicenseSubmit}>
              <div style={{ marginBottom: '10px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '5px' }}>License Key</label>
                <input
                  type="text"
                  value={licenseKey}
                  style={{ width: "60%" }}
                  onChange={(e) => setLicenseKey(e.target.value)}
                  required
                />
                {licenseError && <p className="error" style={{ color: 'red' }}>{licenseError}</p>}
              </div>
              <div className="modal-buttons">
                <button type="submit">Submit</button>
                <button onClick={() => { setLicenseKey(""); setLicenseError(""); setShowLicenseModal(false); }}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
}

export default Dash;
